export default [
  'WW',
  'AU',
  'BR',
  'CA',
  'CH',
  'CN',
  'DE',
  'ES',
  'FR',
  'GB',
  'IT',
  'JP',
  'KR',
  'MX',
  'NL',
  'NO',
  'PT',
  'RU',
  'SA',
  'SE',
  'TH',
  'TW',
  'US',
]
